<template>
  <div>
    <div class="max-resolution">
      <div class="banner page-head flex-box" style="min-height: 100px">
        <div class="w-100">
          <div class="banner-caption text-center">
            <h2 class="features-header-text ml-0 mt-5 text-center">Retail</h2>
            <h4 class="hc-header">
              <strong>
                Enhance Retailing Experience with Conversational AI</strong
              >
            </h4>
            <h5 class="w-50 mx-auto hc-subhead">
              Conversational AI solution enhances overall user experience
              thereby
              <br />
              improving customer satisfaction.
            </h5>
          </div>
        </div>
      </div>
      <div>
        <!-- <nav class="nav flex-column">
        <a class="nav-link active" href="#">Active</a>
        <a class="nav-link" href="#">Link</a>
        <a class="nav-link" href="#">Link</a>
        <a class="nav-link disabled" href="#">Disabled</a>
      </nav> -->
      </div>
      <!-- <div class="container">
      <div class="row">
        <div class="col-sm-5 col-lg-3">
          <ul class="nav nav-tabs flex-column mb-3">
            <li class="nav-item">
              <a class="nav-link active show" data-toggle="tab" href="#tab-1"
                >Lorem Ipsum?</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#tab-2"
                >Do we use it?</a
              >
            </li>
          </ul>
        </div>
        <div class="col-sm-7 col-lg-9">
          <div class="tab-content">
            <div class="tab-pane active show" id="tab-1">
              <div class="row">
                <div class="col-lg-4">
                  <div class="feature-img">
                    <img src="images/user-img-3.jpg" alt="" class="img-fluid" />
                  </div>
                </div>
                <div class="col-lg-8 details">
                  <h3 class="mt-3">What is Lorem Ipsum?</h3>
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy text ever since the 1500s, when an unknown
                    printer took a galley of type and scrambled
                  </p>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="tab-2">
              <div class="row">
                <div class="col-lg-4">
                  <div class="feature-img">
                    <img src="images/user-img-2.jpg" alt="" class="img-fluid" />
                  </div>
                </div>
                <div class="col-lg-8 details">
                  <h3 class="mt-3">Why do we use it?</h3>
                  <p class="font-italic">
                    It is a long established fact that a reader will be
                    distracted by the readable content of a page when looking at
                    its layout. The point of using Lorem Ipsum is that it has a
                    more-or-less normal distribution of letters
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    </div>
    <div style="background-color: rgba(236, 243, 255, 0.33)">
      <div class="max-resolution container d-tb">
        <div class="row">
          <div :class="screen_width_check" class="pr-0">
            <div class="accordion my-5 ml-5" id="retailAccordion">
              <div
                class="card"
                :class="
                  current_active_section_check('list_customer_list', false)
                "
              >
                <div class="card-header" id="headingOne">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link px-0"
                      type="button"
                      data-toggle="collapse"
                      data-target="#list_customer_list"
                      aria-expanded="true"
                      aria-controls="list_customer_list"
                      id="improved_customer_experience"
                    >
                      <img :src="list_customer_list.current_icon" />
                      <span
                        class="retail-tabs-font"
                        :class="
                          current_active_section_check(
                            'list_customer_list',
                            true
                          )
                        "
                      >
                        Improved Customer Experience</span
                      >
                    </button>
                  </h5>
                </div>

                <div
                  id="list_customer_list"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#retailAccordion"
                >
                  <div class="card-body pr-0">
                    <div class="list-group ml-5" id="list-tab" role="tablist">
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action hvr-trg"
                        id="list_product_list"
                        data-toggle="list"
                        href="#list-products"
                        role="tab"
                        aria-controls="products"
                      >
                        <img :src="list_product_list.current_icon" />

                        <span class="pl-3"> Product Search </span>

                        <!-- <img :src="list_product_list.current_icon" /> -->
                        <!-- <span class="pl-3"> Product Search </span></a -->
                      </a>
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action hvr-trg"
                        id="list_discounts_list"
                        data-toggle="list"
                        href="#list-discounts"
                        role="tab"
                        aria-controls="discounts"
                      >
                        <!-- <table>
                          <tr>
                            <td> -->
                        <img :src="list_discounts_list.current_icon" />
                        <!-- </td>
                            <td> -->
                        <span class="pl-3"> Available Discounts & Offers </span>
                        <!-- </td>
                          </tr>
                        </table> -->
                        <!-- <img :src="list_discounts_list.current_icon" />
                        <span class="pl-3"> Available Discounts & Offers </span> -->
                      </a>
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action hvr-trg"
                        id="list_checkout_list"
                        data-toggle="list"
                        href="#list-checkout"
                        role="tab"
                        aria-controls="checkout"
                      >
                        <!-- <table>
                          <tr>
                            <td> -->
                        <img :src="list_checkout_list.current_icon" />
                        <!-- </td>
                            <td> -->
                        <span class="" style="padding-left: 2.2rem">
                          Checkout
                        </span>
                        <!-- </td>
                          </tr>
                        </table> -->
                        <!-- <img :src="list_checkout_list.current_icon" />
                        <span class="pl-3"> Checkout </span></a -->
                      </a>
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action hvr-trg"
                        id="list_upsell_list"
                        data-toggle="list"
                        href="#list-upsell"
                        role="tab"
                        aria-controls="upsell"
                      >
                        <!-- <table>
                          <tr>
                            <td> -->
                        <img
                          :src="list_upsell_list.current_icon"
                          style="margin-left: -0.79rem"
                        />
                        <!-- </td>
                            <td> -->
                        <span class="" style="padding-left: 1.7rem"
                          >Up-Sell & Cross-Sell
                        </span>
                        <!-- </td>
                          </tr>
                        </table> -->
                        <!-- <img :src="list_upsell_list.current_icon" />
                        <span class="pl-3">Up-Sell & Cross-Sell </span> -->
                      </a>
                      <a
                        href="#list-customer"
                        id="list_customer_list"
                        data-toggle="list"
                        role="tab"
                        aria-controls="customer"
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card mt-5"
                :class="
                  current_active_section_check('list_service_list', false)
                "
              >
                <div class="card-header" id="headingTwo">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link collapsed px-0"
                      type="button"
                      data-toggle="collapse"
                      data-target="#list_service_list"
                      aria-expanded="false"
                      aria-controls="list_service_list"
                      id="seamless_after_sales_service"
                    >
                      <img :src="list_service_list.current_icon" alt="" />
                      <span
                        class="retail-tabs-font"
                        :class="
                          current_active_section_check(
                            'list_service_list',
                            true
                          )
                        "

                      >
                        Seamless After Sales Service</span
                      >
                    </button>
                  </h5>
                </div>
                <div
                  id="list_service_list"
                  class="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#retailAccordion"
                >
                  <div class="card-body pr-0">
                    <div class="list-group ml-5" id="list-tab-2" role="tablist">
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action hvr-trg"
                        id="list_orders_list"
                        data-toggle="list"
                        href="#list-orders"
                        role="tab"
                        aria-controls="orders"
                      >
                        <img :src="list_orders_list.current_icon" />
                        <span class="pl-3"> Orders & Tracking </span></a
                      >
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action hvr-trg"
                        id="list_return_list"
                        data-toggle="list"
                        href="#list-return"
                        role="tab"
                        aria-controls="discounts"
                      >
                        <img :src="list_return_list.current_icon" />
                        <span class="pl-3"> Returns & Refunds </span>
                      </a>
                      <a
                        class="list-group-item retail-tabs-font list-group-item-action"
                        href="#list-seamless"
                        id="list_seamless_list"
                        data-toggle="list"
                        role="tab"
                        aria-controls="discounts"
                        style="display: none"
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-7 pl-0">
            <div class="tab-content my-5" id="nav-tabContent">
              <div
                class="tab-pane fade show active wgt-bg mr-5 image-bdr text-center"
                id="list-customer"
                role="tabpanel"
                aria-labelledby="list_customer_list"
              >
                <img
                  src="@/assets/img/retail/ImprovedCustomerExperience.svg"
                  alt=""
                  class="p-5"
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-products"
                role="tabpanel"
                aria-labelledby="list_product_list"
              >
                <img
                  src="@/assets/img/retail/ProductSearch.svg"
                  alt=""
                  class="p-5"
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-discounts"
                role="tabpanel"
                aria-labelledby="list_discounts_list"
              >
                <img
                  src="@/assets/img/retail/AvailableDiscounts.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-checkout"
                role="tabpanel"
                aria-labelledby="list_checkout_list"
              >
                <img
                  src="@/assets/img/retail/Checkout.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-upsell"
                role="tabpanel"
                aria-labelledby="list_upsell_list"
              >
                <img src="@/assets/img/retail/UpSell.svg" class="p-5" alt="" />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-orders"
                role="tabpanel"
                aria-labelledby="list_orders_list"
              >
                <img
                  src="@/assets/img/retail/OrdersTracking.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-return"
                role="tabpanel"
                aria-labelledby="list_return_list"
              >
                <img
                  src="@/assets/img/retail/ReturnRefund.svg"
                  class="p-5"
                  alt=""
                />
              </div>
              <div
                class="tab-pane fade wgt-bg mr-5 image-bdr text-center"
                id="list-seamless"
                role="tabpanel"
                aria-labelledby="list_seamless_list"
              >
                <img
                  src="@/assets/img/retail/SeamlessAfterSales.svg"
                  class="p-5"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-mb">
        <div
          class="mobile-section m-3"
          :class="check_current_section_mobile('customer', false)"
        >
          <div class="col-sm-1 text-center mb-1 mt-1 px-0">
            <span
              class="mb-headers dt-border mx-1 p-1"
              data-toggle="collapse"
              data-target="#collapseExample"
              aria-expanded="false"
              aria-controls="collapseExample"
              :class="check_current_section_mobile('customer', true)"
              @click="
                (current_active_section_mobile = 'customer') &&
                  (current_active_slide_mobile = null)
              "
              >Improved Customer Experience</span
            >
          </div>
          <div class="collapse show" id="collapseExample">
            <hr class="my-0" />
            <div class="col-sm-1 text-center my-1 px-0">
              <span
                :class="check_current_slide_mobile('search')"
                class="mb-headers dt-border"
                @click="current_active_slide_mobile = 'search'"
                >Product Search</span
              >
              <span class="px-1" style="color: #8a8a8a">|</span>
              <span
                :class="check_current_slide_mobile('discounts')"
                class="mb-headers dt-border"
                @click="current_active_slide_mobile = 'discounts'"
                >Available Discounts & Offers</span
              >
              <span class="px-1" style="color: #8a8a8a">|</span>
              <span
                :class="check_current_slide_mobile('checkout')"
                class="mb-headers dt-border"
                @click="current_active_slide_mobile = 'checkout'"
                >Checkout</span
              >
            </div>
            <div class="col-sm-1 text-center px-3 my-1">
              <!-- <span class="px-2" style="color:#8A8A8A">|</span> -->
              <span
                :class="check_current_slide_mobile('upsell')"
                class="mb-headers dt-border mx-1 p-1"
                @click="current_active_slide_mobile = 'upsell'"
                >Up Sell & Cross Sell</span
              >
            </div>
          </div>
        </div>
        <div
          class="mobile-section m-3"
          :class="check_current_section_mobile('seamless', false)"
        >
          <div class="col-sm-1 text-center mb-1 mt-1 px-0">
            <span
              class="mb-headers dt-border mx-1 p-1"
              data-toggle="collapse"
              data-target="#collapseExample1"
              aria-expanded="false"
              aria-controls="collapseExample1"
              :class="check_current_section_mobile('seamless', true)"
              @click="(current_active_section_mobile = 'seamless') &&
                  (current_active_slide_mobile = null)"
              >Seamless After Sales Service</span
            >
          </div>
          <div class="collapse" id="collapseExample1">
            <hr class="my-0" />
            <div class="col-sm-1 text-center my-1 px-0">
              <span
                :class="check_current_slide_mobile('orders')"
                class="mb-headers dt-border"
                @click="current_active_slide_mobile = 'orders'"
                >Orders & Tracking</span
              >
              <span class="px-2" style="color: #8a8a8a">|</span>
              <span
                :class="check_current_slide_mobile('returns')"
                class="mb-headers dt-border"
                @click="current_active_slide_mobile = 'returns'"
                >Returns & Refunds</span
              >
            </div>
          </div>
        </div>
        <div class="wgt-bg m-3">
          <img
            src="@/assets/img/retail/ImprovedCustomerExperience.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'customer' &&
              current_active_slide_mobile == null
            "
          />
          <img
            src="@/assets/img/retail/ProductSearch.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'customer' &&
              current_active_slide_mobile == 'search'
            "
          />
          <img
            src="@/assets/img/retail/AvailableDiscounts.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'customer' &&
              current_active_slide_mobile == 'discounts'
            "
          />
          <img
            src="@/assets/img/retail/Checkout.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'customer' &&
              current_active_slide_mobile == 'checkout'
            "
          />
          <img
            src="@/assets/img/retail/UpSell.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'customer' &&
              current_active_slide_mobile == 'upsell'
            "
          />
          <img
            src="@/assets/img/retail/OrdersTracking.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'seamless' &&
              current_active_slide_mobile == 'orders'
            "
          />
          <img
            src="@/assets/img/retail/ReturnRefund.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'seamless' &&
              current_active_slide_mobile == 'returns'
            "
          />
          <img
            src="@/assets/img/retail/SeamlessAfterSales.svg"
            alt=""
            class="p-5"
            v-if="
              current_active_section_mobile == 'seamless' &&
              current_active_slide_mobile == null
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "Retail",
  data() {
    return {
      current_active_section: "list_customer_list",
      current_active_slide: null,
      section_values: ["list_customer_list", "list_seamless_list"],
      sections_tabs_values: {
        "list-tab": [
          "list_product_list",
          "list_discounts_list",
          "list_checkout_list",
          "list_upsell_list",
        ],
        "list-tab-2": ["list_orders_list", "list_return_list"],
      },
      list_customer_list: {
        current_icon: require("@/assets/img/retail/ImprovedCustomerExperienceActive.svg"),
        active_icon: require("@/assets/img/retail/ImprovedCustomerExperienceActive.svg"),
        inactive_icon: require("@/assets/img/retail/ImprovedCustomerExperienceInActive.svg"),
      },
      list_product_list: {
        current_icon: require("@/assets/img/retail/ProductSearchInActive.svg"),
        active_icon: require("@/assets/img/retail/ProductSearchActive.svg"),
        inactive_icon: require("@/assets/img/retail/ProductSearchInActive.svg"),
      },
      list_discounts_list: {
        current_icon: require("@/assets/img/retail/AvailableDiscountsInActive.svg"),
        active_icon: require("@/assets/img/retail/AvailableDiscountsActive.svg"),
        inactive_icon: require("@/assets/img/retail/AvailableDiscountsInActive.svg"),
      },
      list_checkout_list: {
        current_icon: require("@/assets/img/retail/CheckoutInActive.svg"),
        active_icon: require("@/assets/img/retail/CheckoutActive.svg"),
        inactive_icon: require("@/assets/img/retail/CheckoutInActive.svg"),
      },
      list_upsell_list: {
        current_icon: require("@/assets/img/retail/UpSellInActive.svg"),
        active_icon: require("@/assets/img/retail/UpSellActive.svg"),
        inactive_icon: require("@/assets/img/retail/UpSellInActive.svg"),
      },
      list_orders_list: {
        current_icon: require("@/assets/img/retail/OrdersTrackingInActive.svg"),
        active_icon: require("@/assets/img/retail/OrdersTrackingActive.svg"),
        inactive_icon: require("@/assets/img/retail/OrdersTrackingInActive.svg"),
      },
      list_return_list: {
        current_icon: require("@/assets/img/retail/ReturnRefundInActive.svg"),
        active_icon: require("@/assets/img/retail/ReturnRefundActive.svg"),
        inactive_icon: require("@/assets/img/retail/ReturnRefundInActive.svg"),
      },
      list_service_list: {
        current_icon: require("@/assets/img/retail/SeamlessAfterSalesInActive.svg"),
        active_icon: require("@/assets/img/retail/SeamlessAfterSalesActive.svg"),
        inactive_icon: require("@/assets/img/retail/SeamlessAfterSalesInActive.svg"),
      },
      current_active_slide_mobile: null,
      current_active_section_mobile: "customer",
      screen_width_check: "",
    };
  },
  mounted() {
    const vm = this;
    this.check_screen_width();
    $("#retailAccordion").on("show.bs.collapse", function (e) {
      // console.log(e.target.id);
      vm.current_active_section = e.target.id;
    });
    $('a[data-toggle="list"]').on("show.bs.tab", function (e) {
      vm.current_active_slide = e.target.id;
      if (e.relatedTarget) {
        // console.log(e.relatedTarget.id) // previous active tab
      }
    });
    $("#collapseExample").on("show.bs.collapse", function () {
      vm.current_active_section_mobile = "customer";
      $("#collapseExample1").collapse("hide");
    });
    $("#collapseExample1").on("show.bs.collapse", function () {
      vm.current_active_section_mobile = "seamless";
      $("#collapseExample").collapse("hide");
    });
    $("#collapseExample").on("hidden.bs.collapse", function () {
      vm.current_active_section_mobile = "seamless";
      $("#collapseExample1").collapse("show");
    });
    $("#collapseExample1").on("hidden.bs.collapse", function () {
      vm.current_active_section_mobile = "customer";
      $("#collapseExample").collapse("show");
    });
    window.onresize = function () {
      vm.check_screen_width();
    };
    $(".hvr-trg").hover(
      function () {
        setTimeout(() => {
          $(this).trigger("click");
        }, 200);
      }
    );
    $("#seamless_after_sales_service").hover(
      function () {
        $(this).trigger("click");
      },
      function () {}
    );
    $("#improved_customer_experience").hover(
      function () {
        $(this).trigger("click");
      },
      function () {}
    );
    
  },
  watch: {
    current_active_slide(newVal, oldVal) {
      if (!this.section_values.includes(newVal)) {
        this[newVal].current_icon = this[newVal].active_icon;
      }
      if (
        oldVal != undefined &&
        oldVal !== null &&
        !this.section_values.includes(oldVal)
      ) {
        this[oldVal].current_icon = this[oldVal].inactive_icon;
      }
    },
    current_active_section(newVal, oldVal) {
      // console.log({ newVal, oldVal });
      this[newVal].current_icon = this[newVal].active_icon;
      if (oldVal != undefined && oldVal !== null) {
        this[oldVal].current_icon = this[oldVal].inactive_icon;
      }
      if (newVal === "list_service_list") {
        this.clear_active_section("list-tab");
        // $("#list_seamless_list").click();
        setTimeout(() => {
          $('#list-tab-2 a[href="#list-seamless"]').tab("show");
        }, 100);
      } else {
        this.clear_active_section("list-tab-2");
        setTimeout(() => {
          $('#list-tab a[href="#list-customer"]').tab("show");
        }, 100);
        // $("#list_customer_list").click();
      }
    },
  },
  methods: {
    current_active_section_check(section, bool) {
      // console.log(section)
      if (section === this.current_active_section) {
        if (bool) {
          return "current-active-session";
        }
      } else {
        if (!bool) {
          return "current-inactive-card";
        }
      }
    },
    clear_active_section(section) {
      document
        .querySelectorAll(`#${section} .list-group-item`)
        .forEach((e) => e.classList.remove("active"));
      this.sections_tabs_values[section].forEach((e) => {
        // console.log(this[e]);
        this[e].current_icon = this[e].inactive_icon;
      });
    },
    check_current_slide_mobile(slide) {
      if (slide === this.current_active_slide_mobile) {
        return "mobile-active";
      } else {
        return "mobile-inactive";
      }
    },
    check_current_section_mobile(section, bool) {
      if (section === this.current_active_section_mobile) {
        if (bool) {
          return "mobile-active";
        } else {
          return "mobile-border-active";
        }
      } else {
        if (bool) {
          return "mobile-inactive";
        } else {
          return "mobile-border-inactive";
        }
      }
    },
    check_screen_width() {
      if (window.matchMedia("(min-width: 1025px)").matches) {
        this.screen_width_check = "col-sm-4";
      } else {
        this.screen_width_check = "col-sm-5";
      }
    },
  },
};
</script>



<style scoped>
.tabs-section {
  overflow: hidden;
  background-color: #333;
  padding: 60px 0px;
}
.tabs-section .feature-img {
  max-height: 255px;
  overflow: hidden;
  border-radius: 10px;
  border: 3px solid #fff;
}
.tabs-section .nav-tabs {
  border: 0;
}
.tabs-section .nav-link {
  border: 0;
  padding: 11px 15px;
  transition: 0.3s;
  color: #fff;
  border-radius: 0;
  border-right: 2px solid #cddc39 !important;
  font-weight: 600;
  font-size: 15px;
}
.tabs-section .nav-link:hover {
  color: #cddc39;
}
.tabs-section .nav-link.active {
  color: #333333;
  background: #cddc39;
}
.tabs-section .nav-link:hover {
  border-right: 4px solid #cddc39;
}
.tabs-section .tab-pane.active {
  -webkit-animation: fadeIn 0.5s ease-out;
  animation: fadeIn 0.5s ease-out;
}
.tabs-section .details h3 {
  font-size: 26px;
  color: #cddc39;
}
.tabs-section .details p {
  color: #aaaaaa;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #ffffff;
  border-color: #dee2e6 #fff #dee2e6 #dee2e6;
}
</style>

<style scoped>
.hc-subhead {
  color: #3a3a3a;
  font: normal normal normal 19px/30px Rubik;
}
.hc-header {
  font-family: 'RubikMedium';
  font-size: 25px;
  line-height: 29px;
  color: #3a3a3a;
  font-weight: 300;
}
.current-inactive-card {
  border-right: 1px solid rgba(207, 103, 103, 0.125) !important;
}
.tab-pane {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0px 10px 10px 10px;
  border-left: 0;
  min-height: 78vh;
}
.retail-tabs-font {
  font: normal normal 500 1rem/1.45rem Rubik;
}
.list-group-item {
  padding-right: 0;
  border-right: none;
  border-left: none;
  min-height: 6vh;
  padding: 0.75rem 0rem;
}
.list-group-item:first-child {
  border-top: none;
}
.list-group-item:last-child {
  border-bottom: none;
}
.list-group-item:nth-last-child(2) {
  border-bottom: none;
}
.list-group-item.active {
  color: #283677;
  background-color: #ffffff;
  border-color: #dcdcdc;
  border-right: none;
  width: 100.4%;
}
.card-header {
  background-color: #ffffff;
  border-bottom: none;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
/* .btn:focus{
  color: #283677;
} */
button {
  text-decoration: none;
}
.btn-link {
  color: #909090;
  font: normal normal normal 18px/25px Rubik;
}
.btn-link:hover {
  text-decoration: none;
}
.btn-link:focus {
  text-decoration: none;
}
.btn:focus {
  box-shadow: none;
}
.current-active-session {
  color: #283677;
}
.card {
  border-right: 0;
}

.mb-headers {
  font: normal normal 500 0.7rem/1.25rem Rubik;
}

.mobile-section {
  border: 0.5px solid #283677;
  border-radius: 5px;
  opacity: 1;
}

.mobile-inactive {
  color: #8a8a8a;
}
.mobile-active {
  color: #283677;
}

.mobile-border-active {
  border: 0.5px solid #283677;
  border-radius: 5px;
}
.mobile-border-inactive {
  border: 0.5px solid #8a8a8a;
  border-radius: 5px;
  width: 60%;
  margin-left: auto !important;
  margin-right: auto !important;
}
.d-mb {
  display: none;
}
.accordion > .card > .card-header :first-child {
  margin-bottom: inherit;
}
@media only screen and (max-width: 600px) {
  .d-tb {
    display: none;
  }
  .d-mb {
    display: grid;
  }
  .wgt-bg {
    border-radius: 10px 10px 10px 10px;
  }
}
/* @media (max-width: 768px) {
  .healthcare-tabs-font {
    font: normal normal 500 0.79rem/1.45rem Rubik;
  }
} */
</style>